export function succeed(value) {
    return { ok: true, value };
}
export function fail(code, message) {
    return { ok: false, error: { code, message } };
}
//# sourceMappingURL=result.js.map